import React, { FC } from 'react';
import { MachinesNowOverview } from './components/MachinesNowOverview';
import { TimelineItemsList } from '@v2/pages/machines/modules/timeline/components/TimelineItemsList/TimelineItemsList';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import { NavigationProps } from '@interfaces/navigation';
import { useTrackMachineLiveOpened } from './hooks/useTrackMachineLiveOpened';

interface MachinesNowOverviewScreenProps extends NavigationProps {}

const MachinesNowOverviewScreen: FC<MachinesNowOverviewScreenProps> = ({ lg }) => {
  useTrackMachineLiveOpened();

  return (
    <MachinesProvider lg={lg} panelViewMode={false} onBack={() => {}} getList={(props) => <TimelineItemsList {...props} />} withDefaultComponent>
      <MachinesNowOverview />
    </MachinesProvider>
  );
};

export default MachinesNowOverviewScreen;
